/**
 * @generated SignedSource<<3544619a4781e193582fb065aac4f119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FiltersMenu_project$data = {
  readonly id: string;
  readonly " $fragmentType": "FiltersMenu_project";
};
export type FiltersMenu_project$key = {
  readonly " $data"?: FiltersMenu_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersMenu_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FiltersMenu_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "10737a2ddd3f3d9a01f47a3d5384848a";

export default node;
